import React from 'react';
import { MultiColumnPanel } from './view/multiColumnPanel2';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'MultiColumnPanel2', 
  itemElt: (item, cmsOption) => <MultiColumnPanel item={item} cmsOption={cmsOption} />
}